
import React from "react";
import { DetailedHTMLProps, FC, SVGProps } from "react";
export const SearchIcon: FC<
DetailedHTMLProps<SVGProps<SVGSVGElement>, SVGSVGElement>
> = ({className}) => (

    <svg className={className} width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="12.1222" cy="11.7666" rx="8.76384" ry="8.98856" stroke="#999999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M18.2178 18.4851L21.6537 22" stroke="#999999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

);